import React from 'react'

const Footer = () => {
    return (
        <footer className='footer'>
            <p className='copyrights text-muted'>
            Shoqa © {new Date().getFullYear()}
            </p>
        </footer>
    )
}

export default Footer
